"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarImageModal = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../button");

var _form = require("../../form");

var _layout = require("../../layout");

var _liveAnnouncer = require("../../live-announcer");

var _modal = require("../../modal");

var _screenReaderOnly = require("../../screen-reader-only");

var _text = require("../../text");

var _utils = require("../../utils");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ToolbarImageModal = function ToolbarImageModal(_ref) {
  var close = _ref.close,
      _ref$defaultValues = _ref.defaultValues,
      defaultValues = _ref$defaultValues === void 0 ? {} : _ref$defaultValues,
      handleOnSubmit = _ref.handleOnSubmit,
      isOpen = _ref.isOpen,
      localization = _ref.localization,
      onClose = _ref.onClose,
      onSetImage = _ref.onSetImage,
      renderImageModalContentProp = _ref.renderImageModalContent,
      setReturnFocus = _ref.setReturnFocus;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      src = _useState2[0],
      setSrc = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      alt = _useState4[0],
      setAlt = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      decorative = _useState6[0],
      setDecorative = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      width = _useState8[0],
      setWidth = _useState8[1];

  var _useState9 = (0, _react.useState)(''),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      height = _useState10[0],
      setHeight = _useState10[1];

  var _useState11 = (0, _react.useState)(undefined),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      ratio = _useState12[0],
      setRatio = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      hasMissingSrcError = _useState14[0],
      setHasMissingSrcError = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      hasMissingAltError = _useState16[0],
      setHasMissingAltError = _useState16[1];

  var _useState17 = (0, _react.useState)(false),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      shouldRetainProportions = _useState18[0],
      setShouldRetainProportions = _useState18[1];

  var modalTitleTextId = (0, _react.useMemo)(function () {
    return (0, _utils.getUniqueId)(_constants.TOOLBAR_MODAL_TITLE_ID);
  }, []);
  var closeDialogTextId = (0, _react.useMemo)(function () {
    return (0, _utils.getUniqueId)(_constants.TOOLBAR_MODAL_CLOSE_TEXT_ID);
  }, []);
  var hasDefaultValues = !!defaultValues.src;
  var urlInputRef = (0, _react.useRef)(null);

  var handleProportionsCheckboxChange = function handleProportionsCheckboxChange(checked) {
    if (checked) {
      setRatio(parseInt(width) / parseInt(height));
      setShouldRetainProportions(true);
    } else {
      setRatio(undefined);
      setShouldRetainProportions(false);
    }
  };

  var handleWidthChange = function handleWidthChange(newWidth) {
    if (ratio) {
      setHeight((parseInt(newWidth) / ratio).toFixed(0));
    }

    setWidth(newWidth);
  };

  var handleHeightChange = function handleHeightChange(newHeight) {
    if (ratio) {
      setWidth((parseInt(newHeight) * ratio).toFixed(0));
    }

    setHeight(newHeight);
  };

  var handleSubmit = function handleSubmit(e) {
    if (handleOnSubmit !== undefined) {
      handleOnSubmit(e, onSetImage);
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    var srcNotSet = !src;
    var altTextNotSet = !alt && !decorative;

    if (srcNotSet || altTextNotSet) {
      setHasMissingSrcError(srcNotSet);
      setHasMissingAltError(altTextNotSet);
      return;
    }

    var imageId = defaultValues.id || (0, _utils.getUniqueId)('rte-image-');
    onSetImage({
      src: src,
      alt: decorative ? undefined : alt,
      title: decorative ? alt : undefined,
      width: !!width ? parseInt(width) : undefined,
      height: !!width ? parseInt(height) : undefined,
      id: imageId
    });
  };

  var handleClose = function handleClose() {
    if (!isOpen) {
      setHasMissingAltError(false);
      setHasMissingAltError(false);
      onClose();
    }
  };

  (0, _react.useEffect)(function () {
    setSrc(defaultValues.src || '');
    setAlt(defaultValues.alt || defaultValues.title || '');

    if (hasDefaultValues && defaultValues.alt) {
      setDecorative(false);
    } else if (hasDefaultValues && !defaultValues.alt) setDecorative(true);

    setWidth(defaultValues.width ? defaultValues.width.toString() : '');
    setHeight(defaultValues.height ? defaultValues.height.toString() : '');

    if (defaultValues.width && defaultValues.height) {
      setRatio(defaultValues.width / defaultValues.height);
      setShouldRetainProportions(true);
    }
  }, [defaultValues, hasDefaultValues]);
  (0, _react.useEffect)(function () {
    if (isOpen && urlInputRef.current) {
      urlInputRef.current.focus();
    }
  }, [isOpen]);

  var labelTexts = _objectSpread(_objectSpread({}, _constants.toolbarImageModalDefaultProps.localization), localization);

  var insertSubmitButtonText = labelTexts.insertSubmitButtonText,
      insertTitleText = labelTexts.insertTitleText,
      updateSubmitButtonText = labelTexts.updateSubmitButtonText,
      updateTitleText = labelTexts.updateTitleText;

  var renderImageModalContent = function renderImageModalContent() {
    if (!!renderImageModalContentProp) {
      return renderImageModalContentProp({
        defaultValues: defaultValues
      });
    } else {
      var altDecorativeFooterInfo = labelTexts.altDecorativeFooterInfo,
          altError = labelTexts.altError,
          altPrompt = labelTexts.altPrompt,
          closeDialogAltText = labelTexts.closeDialogAltText,
          decorativeCheckboxPrompt = labelTexts.decorativeCheckboxPrompt,
          dimensionsTitleText = labelTexts.dimensionsTitleText,
          heightPrompt = labelTexts.heightPrompt,
          retainProportionsCheckboxPrompt = labelTexts.retainProportionsCheckboxPrompt,
          srcPrompt = labelTexts.srcPrompt,
          srcError = labelTexts.srcError,
          widthPrompt = labelTexts.widthPrompt;

      var renderFooter = function renderFooter(_ref2) {
        var decorativeText = _ref2.decorativeText,
            errorText = _ref2.errorText,
            footerProps = _ref2.footerProps,
            isDecorative = _ref2.isDecorative,
            isError = _ref2.isError;

        if (isDecorative) {
          return (0, _core.jsx)(_form.InputFooter, footerProps, decorativeText);
        }

        if (isError) {
          return (0, _core.jsx)(_form.InputFooter, footerProps, (0, _core.jsx)(_liveAnnouncer.LiveAnnouncer, null, (0, _core.jsx)(_liveAnnouncer.LiveRegion, {
            "aria-live": "polite",
            role: _liveAnnouncer.LiveRegionRole.Status
          }, (0, _core.jsx)(_form.InputFooterText, null, errorText))));
        }

        return undefined;
      };

      return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_layout.Col, {
        gridGap: "S500"
      }, (0, _core.jsx)(_layout.Col, {
        gridGap: "S300"
      }, (0, _core.jsx)(_form.InputWrapper, {
        id: "image-url-input",
        labelText: srcPrompt,
        required: true,
        error: hasMissingSrcError,
        footer: function footer(footerProps) {
          return renderFooter({
            footerProps: footerProps,
            isError: hasMissingSrcError,
            errorText: srcError
          });
        }
      }, function (inputProps) {
        return (0, _core.jsx)(_form.Input, (0, _extends2.default)({}, inputProps, {
          value: src,
          onChange: function onChange(e) {
            setHasMissingSrcError(false);
            setSrc(e.target.value);
          },
          ref: urlInputRef
        }));
      }), (0, _core.jsx)(_layout.Col, {
        gridGap: "S200"
      }, (0, _core.jsx)(_form.InputWrapper, {
        id: "image-alt-input",
        labelText: altPrompt,
        required: !decorative,
        error: hasMissingAltError,
        footer: function footer(footerProps) {
          return renderFooter({
            footerProps: footerProps,
            isError: hasMissingAltError,
            errorText: altError,
            isDecorative: decorative,
            decorativeText: altDecorativeFooterInfo
          });
        }
      }, function (inputProps) {
        return (0, _core.jsx)(_form.Input, (0, _extends2.default)({}, inputProps, {
          value: alt,
          onChange: function onChange(e) {
            setHasMissingAltError(false);
            setAlt(e.target.value);
          }
        }));
      }), (0, _core.jsx)(_form.InputWrapper, {
        id: "decorative-image-checkbox",
        labelText: decorativeCheckboxPrompt,
        labelPosition: _form.LabelPosition.Trailing
      }, function (inputProps) {
        return (0, _core.jsx)(_form.Checkbox, (0, _extends2.default)({}, inputProps, {
          checked: decorative,
          onChange: function onChange() {
            !decorative && setHasMissingAltError(false);
            setDecorative(!decorative);
          }
        }));
      }))), !!hasDefaultValues && (0, _core.jsx)(_helperComponents.ImageModalFieldset, null, (0, _core.jsx)(_layout.Col, {
        gridGap: "S300"
      }, (0, _core.jsx)(_helperComponents.ImageModalLegend, null, (0, _core.jsx)(_text.H3, null, dimensionsTitleText)), (0, _core.jsx)(_form.InputWrapper, {
        id: "proportions-checkbox",
        labelText: retainProportionsCheckboxPrompt,
        labelPosition: _form.LabelPosition.Trailing
      }, function (inputProps) {
        return (0, _core.jsx)(_form.Checkbox, (0, _extends2.default)({}, inputProps, {
          checked: shouldRetainProportions,
          onChange: function onChange(e) {
            return handleProportionsCheckboxChange(e.target.checked);
          }
        }));
      }), (0, _core.jsx)(_layout.Row, {
        justifyContent: "space-between",
        gridGap: 'S300'
      }, (0, _core.jsx)(_form.InputWrapper, {
        id: "image-width-input",
        labelText: widthPrompt
      }, function (inputProps) {
        return (0, _core.jsx)(_form.Input, (0, _extends2.default)({}, inputProps, {
          type: "number",
          value: width,
          width: '100%',
          onChange: function onChange(e) {
            return handleWidthChange(e.target.value);
          }
        }));
      }), (0, _core.jsx)(_form.InputWrapper, {
        id: "image-height-input",
        labelText: heightPrompt
      }, function (inputProps) {
        return (0, _core.jsx)(_form.Input, (0, _extends2.default)({}, inputProps, {
          type: "number",
          value: height,
          width: '100%',
          onChange: function onChange(e) {
            return handleHeightChange(e.target.value);
          }
        }));
      }))))), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
        id: closeDialogTextId,
        hidden: true
      }, closeDialogAltText));
    }
  };

  return (0, _core.jsx)(_modal.Modal, {
    setReturnFocus: setReturnFocus,
    "aria-labelledby": modalTitleTextId,
    close: close,
    onClose: handleClose,
    isOpen: isOpen
  }, (0, _core.jsx)("form", {
    onSubmit: handleSubmit
  }, (0, _core.jsx)(_form.FormWrapper, {
    width: _constants.TOOLBAR_MODAL_WIDTH,
    maxWidth: "100%"
  }, (0, _core.jsx)(_modal.ModalContent, {
    buttons: [(0, _core.jsx)(_button.Button, {
      key: "cancel-button",
      variant: _button.ButtonVariant.Tertiary,
      onClick: close,
      "aria-describedby": closeDialogTextId
    }, _constants.tableModalSharedLocalizationProps.cancelButtonText), (0, _core.jsx)(_button.Button, {
      key: "insert-button",
      variant: _button.ButtonVariant.Primary,
      type: "submit",
      "aria-describedby": closeDialogTextId
    }, hasDefaultValues ? updateSubmitButtonText : insertSubmitButtonText)],
    maxWidth: _constants.TOOLBAR_MODAL_WIDTH,
    titleText: hasDefaultValues ? updateTitleText : insertTitleText,
    titleTextId: modalTitleTextId
  }, renderImageModalContent()))));
};

exports.ToolbarImageModal = ToolbarImageModal;